import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  spotifyLogo: {
    maxWidth: "75px",
  },
}));
